<template>
  <v-container class="fill-height background-wrapper" fluid>
    <v-row justify="center" align="center">
      <v-col cols="12" sm="6" md="4" lg="4">
        <v-card>
          <div style="display: flex; justify-content: flex-end; padding: 8px;">
            <LanguageSwitcher />
          </div>
          <v-card-title class="primary">
            <span class="headline">{{ $t('otp.title') }}</span>
          </v-card-title>
          <v-card-text>
            <v-form @submit.prevent="login">
              <v-otp-input
                  :length="6"
                  v-model="otpCode"
                  required
                  variant="solo"
              />

              <v-btn
                  block type="submit"
                  :class="{ 'custom-btn-active': isOTPCodeFilled, 'custom-btn-inactive': !isOTPCodeFilled }"
                  :disabled="!isOTPCodeFilled"
              >
                {{ $t('otp.button') }}
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { BACKEND_API_ENDPOINT } from '@/api';
import axios from 'axios'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

axios.defaults.withCredentials = true;

export default {
  name: 'VerifyOTP',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      otpCode: '',
    };
  },

  methods: {
    async login() {
      console.log(document.cookie)
      try {
        const response = await axios.post(BACKEND_API_ENDPOINT+'/verify-otp', {
          otp_code: this.otpCode,
          sent_otp: localStorage.getItem('sent_otp'),
          phone_number: localStorage.getItem('phone_number'),
          method: localStorage.getItem('method'),
        }, {
          withCredentials: true,
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'Access-Control-Allow-Origin': '*',
          }
        });

        if (response.data.status === 'success') {
          localStorage.setItem('jwtToken', response.data.data.token)

          localStorage.removeItem('sent_otp');
          localStorage.removeItem('phone_number');
          localStorage.removeItem('method');

          this.$router.push('dashboard');
        } else {
          console.error('Ошибка при верификации OTP кода:', response.data.message);
        }
      } catch (error) {
        console.error('Ошибка при отправке запроса:', error);
      }
    }
  },

  computed: {
    isOTPCodeFilled() {
      return this.otpCode.length === 6;
    },
  }

}
</script>

<style scoped>
.background-wrapper {
  background-color: #71b646;
}

.custom-btn-active {
  background: linear-gradient(241.48deg, #07a01d -24.3%, #d5cb6c 172.89%);;
  color: white;
  font-weight: bolder;
  padding: 12px 0
}

.custom-btn-inactive {
  background-color: #F8F8F8;
  color: black;
  font-weight: bolder;
  padding: 20px 0
}
</style>
